import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { useState } from "react"
import { useCreatePatient } from "@/services/query/patients.query"
import { Plus } from "lucide-react"
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

export function AddPatientDialog() {
  const [open, setOpen] = useState(false)
  const [formData, setFormData] = useState({ user_name: "", phone_number: "" })
  const createPatientMutation = useCreatePatient()

  const handleSubmit = async (e) => {
    e.preventDefault()
    await createPatientMutation.mutateAsync(formData)
    setOpen(false)
    setFormData({ user_name: "", phone_number: "" })
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button className="gap-2">
          <Plus className="h-4 w-4" />
          Add Patient
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Add New Patient</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4 mt-4">
          <div className="grid gap-2">
            <Label htmlFor="name">Patient Name</Label>
            <Input
              id="name"
              value={formData.user_name}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  user_name: e.target.value,
                }))
              }
              required
            />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="phone">Phone Number</Label>
            <PhoneInput
              country={'in'}
              value={formData.phone_number}
              onChange={(phone) =>
                setFormData((prev) => ({
                  ...prev,
                  phone_number: phone,
                }))
              }
              inputProps={{
                id: 'phone',
                required: true,
              }}
              containerClass="!w-full"
              inputClass="!w-full"
            />
          </div>
          <div className="flex justify-end gap-3">
            <Button
              type="button"
              variant="outline"
              onClick={() => setOpen(false)}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              disabled={createPatientMutation.isPending}
            >
              {createPatientMutation.isPending ? "Adding..." : "Add Patient"}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  )
}
